export default __webpack_public_path__ + "static/desktop-banner-143ddd0f871e4d8f2f0c0dca287a335e.webp";